import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import api from '../../api';
import { useParticipantTheme } from '../../utils/theme';
import { qaParticipantUrl, useQaUpdates } from './useQa';
import { companyLogoUrl } from '../../utils/companyLogo';
import { questionsWord } from './qaUtils';
import { shareUrl } from '../presentations/shareUtils';
import './Qa.css';

const TOP_COUNT = 6;

// Экран для проектора: вопрос, выбранный ведущим, топ вопросов по голосам и QR для участников.
function QaScreen() {
    const { sessionRef } = useParams();
    const [data, setData] = useState(null);
    useParticipantTheme(data?.settings?.theme);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        try {
            const res = await api.get(`/public/qa/${sessionRef}`);
            setData(res.data);
            setError(null);
        } catch {
            setError('Сессия вопросов не найдена');
        }
    }, [sessionRef]);

    useEffect(() => { load(); }, [load]);
    useQaUpdates(data?.session?.public_id || sessionRef, load);

    if (error) return <div className="qa-screen"><div className="qa-screen__empty">{error}</div></div>;
    if (!data) return <div className="qa-screen"><div className="qa-screen__empty">Загрузка…</div></div>;

    const { session, settings, questions } = data;
    const live = questions.filter((q) => q.status === 'approved');
    const pinned = live.find((q) => q.pinned);
    const top = live.filter((q) => !q.pinned).slice(0, TOP_COUNT);
    const link = qaParticipantUrl(session.public_id);

    return (
        <div className="qa-screen">
            <header className="qa-screen__header">
                <div className="qa-screen__heading">
                    {session.company_logo_path && (
                        <div className="qa-logo qa-logo--screen">
                            <img src={companyLogoUrl(session.company_logo_path)} alt="Логотип" />
                        </div>
                    )}
                    <div>
                    <div className="qa-screen__label">Вопросы спикеру</div>
                    <h1 className="qa-screen__title">{session.title}</h1>
                    </div>
                </div>
                <div className="qa-screen__count">{live.length} {questionsWord(live.length)}</div>
            </header>

            <div className="qa-screen__body">
                <section className="qa-screen__main">
                    {pinned ? (
                        <div className="qa-screen__pinned">
                            <div className="qa-screen__pinned-label">Обсуждаем</div>
                            <p className="qa-screen__pinned-text">{pinned.text}</p>
                            <div className="qa-screen__pinned-votes">▲ {pinned.votes}</div>
                        </div>
                    ) : null}

                    {top.length > 0 ? (
                        <ol className="qa-screen__list">
                            {top.map((q) => (
                                <li key={q.id}>
                                    <span className="qa-screen__votes">▲ {q.votes}</span>
                                    <span className="qa-screen__text">{q.text}</span>
                                </li>
                            ))}
                        </ol>
                    ) : !pinned && (
                        <div className="qa-screen__empty">
                            {settings.enabled ? 'Задайте свой вопрос — отсканируйте QR-код' : 'Приём вопросов пока закрыт'}
                        </div>
                    )}
                </section>

                <aside className="qa-screen__qr">
                    <div className="qa-screen__qr-box"><QRCodeSVG value={link} size={220} level="M" /></div>
                    <div className="qa-screen__qr-text">
                        {settings.enabled ? 'Задайте вопрос и голосуйте за интересные' : 'Приём вопросов закрыт'}
                    </div>
                    <div className="qa-screen__qr-link">{link.replace(/^https?:\/\//, '')}</div>
                    {data.share?.enabled && data.share.qr && (
                        <div className="qa-screen__share">
                            <div className="qa-screen__qr-box qa-screen__qr-box--small">
                                <QRCodeSVG value={shareUrl('qa', session.public_id)} size={140} level="M" />
                            </div>
                            <div className="qa-screen__share-text">Получить презентацию</div>
                        </div>
                    )}
                </aside>
            </div>
        </div>
    );
}

export default QaScreen;
